// extracted by mini-css-extract-plugin
module.exports = {"validation-text":"validation-text"};